import React, { memo } from 'react';

import styled, { css } from 'styled-components';

import { getFontFamily } from 'services/FontService';

export interface ITitle extends ITitleStyle {
  text: string;
  position?: 'left' | 'top';
}

export interface ITitleStyle {
  width?: string;
  className?: string;
}

export const Title = memo(
  ({ text, position = 'top', width, className }: ITitle) => (
    <TitleContainer
      position={position}
      text={text}
      className={className}
      width={width}
    >
      <TextStyled>{text}</TextStyled>

      <Triangle />
    </TitleContainer>
  ),
);

const Triangle = styled.div`
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid var(--k-border-263446-a800);
  top: 100%;
  left: calc(50% - 5px);
  position: absolute;
`;

const TitleContainer = styled.div<ITitle>`
  z-index: 100;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px 16px;
  background: var(--k-bg-263446-a800);
  border-radius: 4px;
  display: block;
  color: var(--k-fg-ffffff);
  position: absolute;
  box-sizing: border-box;
  width: max-content;
  ${({ width }) => {
    if (width) {
      return css`
        max-width: ${width};
        white-space: initial;
      `;
    }

    return css`
      white-space: nowrap;
    `;
  }}
  letter-spacing: initial;
  ${({ position }) => {
    switch (position) {
      case 'top':
        return css`
          bottom: calc(100% + 16px);
          left: 50%;
          transform: translateX(-50%);
        `;
      case 'left':
        return css`
          top: 50%;
          right: calc(100% + 16px);
          transform: translateY(-50%);

          & > ${Triangle} {
            top: 50%;
            left: calc(100%);
            transform: translateY(-50%);
            border-top: 5px solid transparent;
            border-bottom: 5px solid transparent;
            border-left: 5px solid var(--k-border-263446-a800);
          }
        `;
      default:
        return css``;
    }
  }}
`;

const TextStyled = styled.span<ITitleStyle>`
  font-family: ${getFontFamily('medium')};
  font-weight: initial;
  font-size: 12px;
  line-height: 16px;
  text-align: center;
`;
